import { render } from "./LandingGlobalWarmingRisingSeaLevel.vue?vue&type=template&id=6214d15a&ts=true"
import script from "./LandingGlobalWarmingRisingSeaLevel.vue?vue&type=script&lang=ts"
export * from "./LandingGlobalWarmingRisingSeaLevel.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__